export const setCookie = (name: string, value: string, path: string, days?: number) => {
  let expires = "";
  if (days) {
    expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  }
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=${path}`;
};

export const getCookie = (name: string) => {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return "";
};
